import { APIRequest } from './apiRequest';
import { HttpClientHandler, HttpClientCredendtial, HttpClient } from '../../utils/httpclient/httpclient';
import { UserContext } from '../../utils/usercontext/usercontext';
import { BaseContext } from '../../utils/basecontext';




export const POST = "post";
export const GET = "get";
export const DELETE = "delete";
export const PUT = "put";

export interface API<T extends APIRequest> 
{
    generateRequest(request: T, HttpClientHandler: HttpClientHandler): API<T>;
    execute(): void;
}

export abstract class APIImpl<T extends APIRequest> implements API<T>, HttpClientCredendtial
{
    private request: T;

    constructor(private httpClient: HttpClient, private context: BaseContext)
    {
    
    }

    generateRequest(request: T, httpClientHandler: HttpClientHandler): API<T>
    {
        this.request = request;

        this.httpClient.createRequest(this.context, this.formatRequest(this.getRequestData()), this)
                       .setHttpClientHandler(httpClientHandler);
        return this;
    }

    execute()
    {
      this.httpClient.execute();
    }

    getAPIURL(): string
    {
        return "";
    }

    getBASEURL(): string
    {
        return this.context.getProperty().getBaseURL() + 
            this.getAPIURL();
    }

    getHttpMethod(): string
    {
        return POST;
    }

    getQueryParams(): string
    {
        return "";
    }

    getContext(): BaseContext
    {
        return this.context;
    }
   

    getHttpHeaders(): string
    {
         return {
            //   "fingerPrint" : "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
            // "appId" : "com.sixdee.callertunes_etisalat",
            "appId" : "com.sixdee.mpt_rbt_portal",
            "appVersion" : "1.0.6",
            "channelId" : this.context.getUserContext().getChannelId(),
            "versionCode" : "7",
            "os" : "ios",
            "deviceId" : "0191212",
            "notificationTrackingId" : "",
            "Access-Control-Allow-Origin":"https://ringtunetb.mpt.com.mm",
            // "Content-Type":'application/x-www-form-urlencoded',
            "accessToken" : this.context.getUserContext().getAccessToken(),
            "Cache-Control": "public, max-age=0, must-revalidate"
        } as any; 


         /* let headers:any = {};
        //headers['content-type'] = 'application/json';
        //headers['content-type'] = 'application/x-www-form-urlencoded';
        //headers['Access-Control-Allow-Origin'] = '*';
        headers["fingerPrint"] = "DD:EB:B6:7C:BD:27:AB:D2:9F:98:45:95:C1:65:49:5F:75:98:9E:31:83:5A:3D:E2:81:4B:E9:E3:F1:8B:B3:EC",
        headers["appId"] = "com.sixdee.callertunes_etisalat",
        headers["appVersion"] = "1.0.6",
        headers["channelId"] = "9",
        headers["versionCode"] = "7",
        headers["os"] = "ios",
        headers["deviceId"] = "0191212",
        headers["notificationTrackingId"] = "",
        headers["accessToken"] = this.userContext.getAccessToken();
        
        return headers; */ 
    }

    protected getRequestData(): any
    {
        return "";
    }

    protected getRequest(): T
    {
        return this.request;
    }

    protected getUserContext(): UserContext
    {
        return this.context.getUserContext();
    }
    
    protected formatRequest(requestData: any): any
    {
        //return JSON.stringify(requestData);
        return requestData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/api.ts